import React, { useEffect, useState } from "react"
import { withRouter, Link } from "react-router-dom"

import MetaTags from "react-meta-tags"

import { Container } from "reactstrap"
import Breadcrumbs from "components/Common/Breadcrumb"
import Table from "./Table"
import { useSelector, useDispatch } from "react-redux"
import { getAllMultiBetBonuses } from "store/MultiBetBonus/actions"
import {sitename} from "../../../constants/constants";

const MultiBetBonus = props => {
  const dispatch = useDispatch()

  useEffect(() => {
    dispatch(getAllMultiBetBonuses())
  }, [])

  const MultiBetBonuses = useSelector(
    state => state.multiBetBonuses.Index ?? []
  )

  return (
    <React.Fragment>
      <div className="page-content">
        <MetaTags>
          <title>{sitename}</title>
        </MetaTags>
        <Container fluid>
          {/* Render Breadcrumb */}
          <Breadcrumbs title="Admin" breadcrumbItem="Multi Bet Bonus" />
        </Container>
        <Table data={MultiBetBonuses} />
      </div>
    </React.Fragment>
  )
}

export default withRouter(MultiBetBonus)
